import { formattedDateTime } from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import type { CommentBookmarkRecord } from "@circle-react/types/Bookmarks";
import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export interface CommentProps {
  bookmark: CommentBookmarkRecord;
}

export const Comment = ({ bookmark }: CommentProps) => {
  const {
    created_at,
    title,
    author_image: authorImage,
    author_name: authorName,
    plain_text_body: plainTextBody,
    attachment_count: attachmentCount,
  } = bookmark.bookmark_record ?? {};

  const createdAtString = formattedDateTime({
    dateTime: created_at ? new Date(created_at) : new Date(),
    format: "long_date",
  });

  const hasAttachments = Boolean(attachmentCount && attachmentCount > 0);

  return (
    <div className="flex w-full flex-col gap-2.5">
      <Typography variant="label-xs" truncate>
        {title}
      </Typography>
      <div className="flex items-start gap-3">
        <Avatar src={authorImage ?? ""} name={authorName ?? ""} size="lg" />

        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-baseline gap-2">
            <Typography variant="label-sm" truncate>
              {authorName}
            </Typography>
            <Typography variant="caption" color="tertiary" className="shrink-0">
              {createdAtString}
            </Typography>
          </div>

          {plainTextBody && plainTextBody.trim() !== "" ? (
            <Typography
              variant="body-sm"
              color="secondary"
              className="overflow-anywhere line-clamp-2"
            >
              {plainTextBody}
            </Typography>
          ) : (
            hasAttachments && (
              <Typography variant="body-sm" color="secondary">
                {t("bookmarks.attachments_count", {
                  count: attachmentCount,
                })}
              </Typography>
            )
          )}
        </div>
      </div>
    </div>
  );
};
